import React from 'react';
import './SGText.scss';

interface IProps {
  children: React.ReactNode;
  className?: string;
}

interface IPProps {
  children: React.ReactNode;
  className?: string;
  weight: 'medium' | 'bold' | 'base';
  size: 'medium' | 'small' | 'base';
}

const H1 = ({ children, className = '' }: IProps) => (
  <h1 className={`fonts-h1 ${className}`}>{children}</h1>
);
const H2 = ({ children, className = '' }: IProps) => (
  <h2 className={`fonts-h2 ${className}`}>{children}</h2>
);
const H3 = ({ children, className = '' }: IProps) => (
  <h3 className={`fonts-h3 ${className}`}>{children}</h3>
);
const H4 = ({ children, className = '' }: IProps) => (
  <h4 className={`fonts-h4 ${className}`}>{children}</h4>
);
const H5 = ({ children, className = '' }: IProps) => (
  <h5 className={`fonts-h5 ${className}`}>{children}</h5>
);

const P = ({ children, className, weight, size }: IPProps) => (
  <p className={`text-p font-${size} font-w-${weight} ${className}`}>
    {children}
  </p>
);

const DIV = ({ children, className = '', weight, size }: IPProps) => (
  <div className={`text-p font-${size} font-w-${weight} ${className}`}>
    {children}
  </div>
);

export const SGText = {
  H1,
  H2,
  H3,
  H4,
  H5,
  P,
  DIV,
};
